import { render, staticRenderFns } from "./PostAccountCompanyTotal.vue?vue&type=template&id=16b84978&scoped=true"
import script from "./PostAccountCompanyTotal.vue?vue&type=script&lang=js"
export * from "./PostAccountCompanyTotal.vue?vue&type=script&lang=js"
import style0 from "./PostAccountCompanyTotal.vue?vue&type=style&index=0&id=16b84978&prod&lang=scss"
import style1 from "./PostAccountCompanyTotal.vue?vue&type=style&index=1&id=16b84978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b84978",
  null
  
)

export default component.exports